import HomeContentsKr from '@di-shared/features/home/kr/HomeContents.kr';
import {Suspense} from 'react';
import {RegionType} from '@shared/cci/features/const/environment';
import environmentStore, {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import HomeContentsEu from '@di-shared/features/home/eu/HomeContents.eu';

export interface HomePageProps {
  vin: string;
}

function HomePage({vin}: HomePageProps) {
  const region = useEnvironmentStore((state) => state.region);
  const puid = environmentStore.getState().puid;
  const ccid = environmentStore.getState().ccid;
  return region === RegionType.KR ? (
    <Suspense>
      <HomeContentsKr
        vin={vin}
        puid={puid}
        ccid={ccid}
      />
    </Suspense>
  ) : (
    <Suspense>
      <HomeContentsEu vin={vin} />
    </Suspense>
  );
}

export default HomePage;
